import React, { useState } from "react";

interface ISliderInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {}

const SliderInput = React.forwardRef<HTMLInputElement, ISliderInputProps>(
    (props, ref) => {
        const [value, setValue] = useState(props.defaultValue);

        return (
            <div className="d-flex align-items-center">
                <input
                    {...props}
                    type="range"
                    ref={ref}
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                />
                <span className="ml-2 p-2">{value}</span>
            </div>
        );
    }
);

export default SliderInput;
